import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const MobileProductCardSkeleton = ({ ColourId }) => (
	<li className="flex flex-col xs:px-2 w-full" data-lazy-sku={ColourId}>
		<div className="bg-white rounded-lg h-full">
			<div className="flex p-2 pb-0">
				<div className="flex flex-col justify-between w-1/3 p-2 pl-0">
					<Skeleton height={120} className="mb-4" />
					<Skeleton count={3} />
				</div>
				<div className="w-2/3 p-2 pr-0">
					{new Array(8).fill(0).map(() => (
						<React.Fragment>
							<Skeleton />
							<Skeleton width="50%" />
						</React.Fragment>
					))}
				</div>
			</div>

			<div className="flex flex-col p-2 pt-0">
				<Skeleton height={40} />
				<Skeleton height={40} />
			</div>
		</div>
	</li>
);

export default MobileProductCardSkeleton;
